var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrectGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 2.8125C3.06434 2.8125 2.8125 3.06434 2.8125 3.375V14.625C2.8125 14.9357 3.06434 15.1875 3.375 15.1875H14.625C14.9357 15.1875 15.1875 14.9357 15.1875 14.625V7.5C15.1875 7.18934 15.4393 6.9375 15.75 6.9375C16.0607 6.9375 16.3125 7.18934 16.3125 7.5V14.625C16.3125 15.557 15.557 16.3125 14.625 16.3125H3.375C2.44303 16.3125 1.6875 15.557 1.6875 14.625V3.375C1.6875 2.44302 2.44302 1.6875 3.375 1.6875H11.25C11.5607 1.6875 11.8125 1.93934 11.8125 2.25C11.8125 2.56066 11.5607 2.8125 11.25 2.8125H3.375Z",
    fill: "#324705"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.702 2.16732C15.9548 2.34789 16.0133 2.6992 15.8327 2.95199L10.2077 10.827C10.1179 10.9527 9.98038 11.036 9.82735 11.0572C9.67431 11.0784 9.51928 11.0358 9.39863 10.9393L5.64863 7.93928C5.40604 7.74521 5.36671 7.39124 5.56078 7.14865C5.75485 6.90607 6.10883 6.86674 6.35141 7.06081L9.63756 9.68973L14.9173 2.2981C15.0979 2.0453 15.4492 1.98675 15.702 2.16732Z",
    fill: "#324705"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectGreen);
export default __webpack_public_path__ + "static/media/correct-green.e23c0f6d9047b441020a4300b42ca431.svg";
export { ForwardRef as ReactComponent };